import React from 'react'
import { IconCheck } from '@tabler/icons-react'
import { useMantineTheme } from '@mantine/core'

export const ValueCell = ({ children }: { children?: React.ReactNode }) => {
  return <Cell className="text-center">{children}</Cell>
}

export const Cell = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <td width="226" className={className}>
      {children}
    </td>
  )
}

export const CheckCell = () => {
  const theme = useMantineTheme()

  return (
    <ValueCell>
      <IconCheck color={theme.colors.brandBlue[7]} size={24} />
    </ValueCell>
  )
}
